__turbopack_context__.v({
  "grid": "ProfileSection-module__dSgAiG__grid",
  "loader": "ProfileSection-module__dSgAiG__loader",
  "loading": "ProfileSection-module__dSgAiG__loading",
  "nullState": "ProfileSection-module__dSgAiG__nullState",
  "profileSection": "ProfileSection-module__dSgAiG__profileSection",
  "scrollGrid": "ProfileSection-module__dSgAiG__scrollGrid",
  "title": "ProfileSection-module__dSgAiG__title",
});
